import { StoreItemCategory, StoreMapType } from '../../entity_datas/StoreEnums.ts';
import { LobbyImage } from '@colonist/types';
import { BaseStoreItem } from '../BaseStoreItem.ts';
export class SIMapEarth extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.Earth, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.earth.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.earth.description', this.price = 500, this.image = LobbyImage.MapEarthPreview, this.activeInStore = true;
    }
}
export class SIMapUSA extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.USA, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.usa.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.usa.description', this.price = 500, this.image = LobbyImage.MapUSAPreview, this.activeInStore = true;
    }
}
export class SIMapUK extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.UK, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.uk.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.uk.description', this.price = 500, this.image = LobbyImage.MapUKPreview, this.activeInStore = true;
    }
}
export class SIMapDiamond extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.Diamond, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.diamond.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.diamond.description', this.price = 500, this.image = LobbyImage.MapDiamondPreview, this.activeInStore = true;
    }
}
export class SIMapGear extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.Gear, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.gear.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.gear.description', this.price = 500, this.image = LobbyImage.MapGearPreview, this.activeInStore = true;
    }
}
export class SIMapLakes extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.Lakes, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.lakes.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.lakes.description', this.price = 500, this.image = LobbyImage.MapLakesPreview, this.activeInStore = true;
    }
}
export class SIMapPond extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.Pond, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.pond.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.pond.description', this.price = 500, this.image = LobbyImage.MapPondPreview, this.activeInStore = true;
    }
}
export class SIMapTwirl extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.Twirl, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.twirl.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.twirl.description', this.price = 500, this.image = LobbyImage.MapTwirlPreview, this.activeInStore = true;
    }
}
export class SIMapRandomBase extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.Classic4PRandom, this.name = {
            key: 'strings:colonistCommon.gameMaps.classic.random4P.title'
        }, this.description = 'strings:colonistCommon.gameMaps.classic.random4P.description', this.price = 500, this.image = LobbyImage.MapRandomBasePreview, this.activeInStore = true;
    }
}
export class SIMapShuffleBoard extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.ShuffleBoard, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.shuffleBoard.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.shuffleBoard.description', this.price = 500, this.image = LobbyImage.MapShuffleBoardPreview, this.activeInStore = true;
    }
}
export class SIMapBlackForest extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.BlackForest, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.blackForest.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.blackForest.description', this.price = 500, this.image = LobbyImage.MapBlackForestPreview, this.activeInStore = true;
    }
}
export class SIMapVolcano extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.Volcano, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.volcano.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.volcano.description', this.price = 500, this.image = LobbyImage.MapVolcanoPreview, this.activeInStore = true;
    }
}
export class SIMapGoldRush extends BaseStoreItem {
    constructor(...args){
        super(...args), this.category = StoreItemCategory.Map, this.type = StoreMapType.GoldRush, this.name = {
            key: 'strings:colonistCommon.gameMaps.fun.goldRush.title'
        }, this.description = 'strings:colonistCommon.gameMaps.fun.goldRush.description', this.price = 500, this.image = LobbyImage.MapGoldRushPreview, this.activeInStore = true;
    }
}
